export default {"src":"/_next/static/image/public/images/flags/flag_53.379af54870c3f30c1dba2cb261aaa359.svg","height":16,"width":24};